import { AppKitNetwork, mainnet, plumeMainnet } from "@reown/appkit/networks";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { QueryClient } from "@tanstack/react-query";

import { viemChains } from "@/data/chains";
import { projectId } from "@/lib/wagmi";

// If no trackingId is provided, analytics will not be initialized
export const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID || "";

export const queryClient = new QueryClient();

// Get IDs of predefined chains to avoid duplicates
export const predefinedChainIds = new Set<number>([
  mainnet.id,
  plumeMainnet.id,
]);

// Filter out chains that are already defined in viem/chains
export const uniqueViemChains = viemChains.filter((chain) => {
  const chainId: number = Number(chain.id);
  return !predefinedChainIds.has(chainId);
});

// Combine predefined chains with converted chains, avoiding duplicates
export const allNetworks: [AppKitNetwork, ...AppKitNetwork[]] = [
  mainnet,
  plumeMainnet,
  ...uniqueViemChains,
] as [AppKitNetwork, ...AppKitNetwork[]];

export const adapter = new WagmiAdapter({
  networks: allNetworks,
  projectId,
  ssr: false,
});

export const referrerSessionKey = "referrer";
